export default class TopNMode {
    private static readonly SPINNER = "<i class=\"fas fa-circle-o-notch fa-spin pull-right\" aria-hidden=\"true\"></i>";

    public static readonly MANUAL = new TopNMode("", false);
    public static readonly AUTO = new TopNMode(TopNMode.SPINNER, true);
    public static readonly CODE_MANUAL = new TopNMode(TopNMode.SPINNER, false);

    constructor(
        public fontAwesomeHtml: string,
        public autoClose: boolean,
    ) {}

    /**
     * Convert legacy mode (bool) to new mode
     */
    public static convertLegacyMode(mode: boolean) {
        return (mode) ? TopNMode.AUTO : TopNMode.MANUAL;
    }
}
